import { render, staticRenderFns } from "./arrangeTask.vue?vue&type=template&id=76ea08ca&scoped=true"
import script from "./arrangeTask.vue?vue&type=script&lang=js"
export * from "./arrangeTask.vue?vue&type=script&lang=js"
import style0 from "./arrangeTask.vue?vue&type=style&index=0&id=76ea08ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ea08ca",
  null
  
)

export default component.exports